import { render, staticRenderFns } from "./RandomCallAgora.vue?vue&type=template&id=7b9b56d6&scoped=true&"
import script from "./RandomCallAgora.vue?vue&type=script&lang=js&"
export * from "./RandomCallAgora.vue?vue&type=script&lang=js&"
import style0 from "./RandomCallAgora.vue?vue&type=style&index=0&id=7b9b56d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9b56d6",
  null
  
)

export default component.exports